// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"press-quote_wrapper__fZbVS","quote":"press-quote_quote__cXOZO"};